import React, { useEffect, useState } from "react";

import L from 'leaflet';
import "leaflet.heat";

import LoadingBox from "components/LoadingBox";

import "assets/css/map.css";

export default function MapaCalorLeaflet(props) {
    const {
        showLoading,
        centerMap,
        zoomMap,
        markers
    } = props;

    const [map, set_map] = useState(null);
    useEffect(() => {
        loadHeatMap();
    }, []);
    const loadHeatMap = () => {
        let _map = new L.map("map").setView(centerMap, zoomMap);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(_map);

        set_map(_map);
    }

    useEffect(() => {
        if(markers)
            changePoints();
    }, [markers]);
    const changePoints = () => {
        let _points = markers
            ? markers.map((p) => {
                return [p.lat, p.lng];
            })
            : [];
        
        set_points(_points);
    }

    const [points, set_points] = useState([]);
    useEffect(() => {
        if(points)
            loadPointsMap();
    }, [points]);

    const [layerHeat, set_layerHeat] = useState({});
    const loadPointsMap = () => {
        if (map == null)
            return;

        map.removeLayer(layerHeat);
        
        let _layerHeat = new L.heatLayer(points,{radius:20,blur:15});
        set_layerHeat(_layerHeat);

        map.addLayer(_layerHeat);
        map.setView(centerMap, zoomMap);
    }

    return (
        <>
            <div id="map" style={{ zIndex: "0", height: "90vh" }}>
                <div className="useloading">
                    {showLoading && <LoadingBox />}
                </div>
            </div>
        </>
    )
}